import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import Shipment from 'app/models/shipment';

export default PageableBase.extend({
  model: Shipment,
  key: 'shipments',
  url: appUrl('shipments'),

  initialize(models, { apiModeSelection, dateRange }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = dateRange;

    this.listenTo(this.apiModeSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.dateRange.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/shipments.js